import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TableModule } from 'primeng/table'
import { SharedModule } from '../shared/shared.module'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { InputTextModule } from 'primeng/inputtext'
import { DropdownModule } from 'primeng/dropdown'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { CheckboxModule } from 'primeng/checkbox'
import { TreeSelectModule } from 'primeng/treeselect'
import { TooltipModule } from 'primeng/tooltip'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { SelectButtonModule } from 'primeng/selectbutton'
import { InputNumberModule } from 'primeng/inputnumber'
import { MatSortModule } from '@angular/material/sort'
import { MatIconModule } from '@angular/material/icon'
import { MatTableModule } from '@angular/material/table'
import { BrowserModule } from '@angular/platform-browser'
import { ProgressBarModule } from 'primeng/progressbar'
import { MatStepperModule } from '@angular/material/stepper'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { VetcorPricingLandingComponent } from './vetcor-pricing-landing/vetcor-pricing-landing.component'
import { VetcorPricingAdminComponent } from './vetcor-pricing-admin/vetcor-pricing-admin.component'
import { VetcorPricingTableComponent } from './vetcor-pricing-table/vetcor-pricing-table.component'
import { VetcorPricingRowComponent } from './vetcor-pricing-table/vetcor-pricing-row/vetcor-pricing-row.component'
import { VetcorPricingActionButtonsComponent } from './vetcor-pricing-table/vetcor-pricing-action-buttons/vetcor-pricing-action-buttons.component'
import { VetcorPricingAdminRequestsComponent } from './vetcor-pricing-admin-requests/vetcor-pricing-admin-requests.component'
import { NgApexchartsModule } from 'ng-apexcharts'
import { MatTooltipModule } from '@angular/material/tooltip'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SelectModule } from 'primeng/select'
import { ListboxModule } from 'primeng/listbox'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { IconFieldModule } from 'primeng/iconfield'
import { InputIconModule } from 'primeng/inputicon'
import { CardModule } from 'primeng/card'
import { VetcorPricingNewCodeComponent } from './vetcor-pricing-new-code/vetcor-pricing-new-code.component'
import { RadioButtonModule } from 'primeng/radiobutton'
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { VetcorPricingNewCodeAdminComponent } from './vetcor-pricing-new-code-admin/vetcor-pricing-new-code-admin.component'
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal'
import { PriceHistoryComponent } from './price-history/price-history.component'
import { VetcorPricingDetailsModal } from './vetcor-pricing-table/vetcor-pricing-details-modal/vetcor-pricing-details-modal.component'
import { VetcorPricingTableHeadersComponent } from './vetcor-pricing-table/vetcor-pricing-table-headers/vetcor-pricing-table-headers.component'
import { RejectPriceModalComponent } from './vetcor-pricing-table/reject-price-modal/reject-price-modal.component'
import { ValidationWarningModalComponent } from './vetcor-pricing-table/validation-warning-modal/validation-warning-modal.component'
import { DatePickerModule } from 'primeng/datepicker'
import { FloatLabelModule } from 'primeng/floatlabel'
import { VetcorUploadDbxModalComponent } from './upload-dbx-modal/upload-dbx-modal.component'
import { HospitalPricingComponent } from './hospital-pricing/hospital-pricing.component'
import { VetcorCoverSheetModalComponent } from './hospital-pricing/coversheet-modal/coversheet-modal.component'
import { VetcorPracticeSettingsModalComponent } from './practice-settings-modal/practice-settings-modal.component'
import { TabsModule } from 'primeng/tabs'
import { CalendlySchedulerComponent } from './calendly-scheduler/calendly-scheduler.component'
import { VetcorUploadCsvModalComponent } from './vetcor-pricing-admin/pricing-admin-upload-csv-modal/pricing-admin-upload-csv-modal.component'
import { VetcorPricingAdminHospitalComponent } from './vetcor-pricing-admin-hospital/vetcor-pricing-admin-hospital.component'
import { RouterModule } from '@angular/router'

@NgModule({
   declarations: [
      VetcorPricingLandingComponent,
      VetcorPricingAdminComponent,
      VetcorPricingTableComponent,
      VetcorPricingRowComponent,
      VetcorPricingActionButtonsComponent,
      VetcorPricingAdminRequestsComponent,
      VetcorPricingAdminHospitalComponent,
      VetcorPricingNewCodeComponent,
      VetcorPricingNewCodeAdminComponent,
      PriceHistoryComponent,
      VetcorPricingDetailsModal,
      VetcorPricingTableHeadersComponent,
      RejectPriceModalComponent,
      ValidationWarningModalComponent,
      HospitalPricingComponent,
	  VetcorCoverSheetModalComponent,
      VetcorPracticeSettingsModalComponent,
      VetcorUploadCsvModalComponent,
      CalendlySchedulerComponent,
      VetcorUploadDbxModalComponent,
   ],
   imports: [
      CommonModule,
      SharedModule,
      AutoCompleteModule,
      ButtonModule,
      CheckboxModule,
      CardModule,
      DialogModule,
      FormsModule,
      DropdownModule,
      SelectModule,
      InputTextModule,
      TableModule,
      TreeSelectModule,
      TooltipModule,
      ScrollingModule,
      CdkVirtualScrollViewport,
      OverlayPanelModule,
      InputNumberModule,
      SelectButtonModule,
      MatSortModule,
      MatIconModule,
      MatTableModule,
      BrowserModule,
      MatTooltipModule,
      ProgressBarModule,
      MatStepperModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
      NgApexchartsModule,
      BrowserAnimationsModule,
      ListboxModule,
      ProgressSpinnerModule,
      IconFieldModule,
      InputIconModule,
      RadioButtonModule,
      ToggleSwitchModule,
      ModalModule,
      DatePickerModule,
      FloatLabelModule,
      TabsModule,
      RouterModule,
   ],
   providers: [BsModalService],
   exports: [],
})
export class VetcorPricingModule {}
